import {
  call, put, select, takeEvery,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import selectors from '@/selectors';
import { wildcardFilter } from '@/utils/resultsHelper';
import { CARDS_PAGE_SIZE, presentationOptions } from '@/constants/states';
import service from '../service';
import {
  showCatalogueTemplateSuccess,
  showCatalogueTemplateDatasetError,
  showCatalogueTemplateError,
  showCatalogueTemplateForDataset,
  showCatalogueTemplates,
  showCatalogueTemplatesError,
} from '../actions';
import actions from '../constants';

export function* catalogueTemplates(action) {
  const items = yield select(selectors.catalogueTemplates);
  const {
    display,
    filter,
    pageSize,
    currentPage,
    enabledFlag,
    disabledFlag,
  } = items[action.category];
  const page = action.page || currentPage;
  const size = action.pageSize || pageSize;
  const includeEnabled = action.enabledFlag || enabledFlag;
  const includeDisabled = action.disabledFlag || disabledFlag;
  const { response, error } = yield call(callAdapter, service.catalogueTemplates(
    wildcardFilter(filter),
    includeEnabled,
    includeDisabled,
    page,
    display === presentationOptions.CARDS ? CARDS_PAGE_SIZE : size,
  ));

  if (error) {
    yield put(showCatalogueTemplatesError(action.category, error));
  } else {
    yield put(showCatalogueTemplates(
      action.category,
      action.append,
      size,
      response.items,
      response.paging.total,
      response.paging.pages,
      response.paging.page,
    ));
  }
}

export function* catalogueTemplate({ category, code, intl }) {
  const { response, error } = yield call(callAdapter, service.catalogueTemplate(code));
  if (error) {
    yield put(showCatalogueTemplateError(category, code, error));
  } else {
    yield put(showCatalogueTemplateSuccess(category, code, response, intl));
  }
}

export function* catalogueTemplateForDataset({
  category,
  code,
  datasetCode,
  intl,
}) {
  const { response, error } = yield call(callAdapter, service.catalogueTemplate(code));
  if (error) {
    yield put(showCatalogueTemplateDatasetError(category, code, datasetCode, error));
  } else {
    yield put(showCatalogueTemplateForDataset(category, code, datasetCode, intl, response));
  }
}

export default function* catalogueTemplatesApi() {
  yield takeEvery(actions.FETCH_CATALOGUE_TEMPLATES, catalogueTemplates);
  yield takeEvery(actions.REFRESH_CATALOGUE_TEMPLATES, catalogueTemplates);
  yield takeEvery(actions.FETCH_CATALOGUE_TEMPLATE, catalogueTemplate);
  yield takeEvery(actions.FETCH_CATALOGUE_TEMPLATE_FOR_DATASET, catalogueTemplateForDataset);
}
